import { useEffect } from 'react';
import { useAnalytics } from '../../../utils/analytics';
import { BaseStepV2 } from '../../common/v2/BaseStepV2';
import { BaseStepPropsV2 } from '../../common/v2/BaseStepV2.types';
import { StepV2MainContent } from '../../common/v2/StepV2MainContent';
import { MainButtonVariant } from '../../styledComponent/Buttons.style';
import {
  GoalsToAchieveDescription,
  GoalsToAchieveGoalContentWrapper,
  GoalsToAchieveGoalDescription,
  GoalsToAchieveGoalItem,
  GoalsToAchieveGoalNumber,
  GoalsToAchieveGoalTitle,
  GoalsToAchieveGoalsWrapper,
  GoalsToAchieveLabel,
  GoalsToAchieveWrapper,
} from './GoalsToAchieveStep.style';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/rootModel';

interface Goal {
  id: string;
  title: string;
  description: string;
}

interface SuggestedGuidesStepProps extends BaseStepPropsV2 {
  label?: string;
  goals?: Goal[];
}

export const GoalsToAchieveStep: React.FC<SuggestedGuidesStepProps> = observer((props) => {
  const { nextStep, label, description, goals: goalsFallback, isActive } = props;
  const { Onboarding } = useMst();
  const analytics = useAnalytics();

  const goalsToDisplay = Onboarding.onboardingGoals.length > 0 ? Onboarding.onboardingGoals : goalsFallback;

  useEffect(() => {
    if (isActive) {
      analytics.track(`view goals to achieve`);
      return window.scrollTo(0, 0);
    }
  }, [analytics, isActive]);

  const handleCtaClick = () => {
    nextStep();
  };

  return (
    <BaseStepV2 {...props}>
      <StepV2MainContent
        {...props}
        description={undefined}
        isButtonDisabled={false}
        isLoading={false}
        onButtonClick={handleCtaClick}
        buttonVariant={MainButtonVariant.Black}
      >
        <GoalsToAchieveWrapper>
          {label && <GoalsToAchieveLabel>{label}</GoalsToAchieveLabel>}
          {description && <GoalsToAchieveDescription>{description}</GoalsToAchieveDescription>}

          <GoalsToAchieveGoalsWrapper>
            {goalsToDisplay &&
              goalsToDisplay.map((item, index) => (
                <GoalsToAchieveGoalItem key={item.id}>
                  <GoalsToAchieveGoalNumber>{index + 1}</GoalsToAchieveGoalNumber>
                  <GoalsToAchieveGoalContentWrapper>
                    <GoalsToAchieveGoalTitle>{item.title}</GoalsToAchieveGoalTitle>
                    <GoalsToAchieveGoalDescription>{item.description}</GoalsToAchieveGoalDescription>
                  </GoalsToAchieveGoalContentWrapper>
                </GoalsToAchieveGoalItem>
              ))}
          </GoalsToAchieveGoalsWrapper>
        </GoalsToAchieveWrapper>
      </StepV2MainContent>
    </BaseStepV2>
  );
});
